class Sofatutor.Classes.TeacherAccountRequestConfirmationPopup
  constructor: ->
    @$selector = $('#teacher-account-confirm-popup')

    if @shouldOpen()
      @$popup = new Foundation.Reveal(@$selector)
      @open()

  open: =>
    @$popup.open()
    @$selector.removeData('shouldOpen')
    @$selector.removeAttr('data-should-open')

  shouldOpen: =>
    @$selector.data('shouldOpen')?
